import { styled } from '@mui/system'
import { fontSizes, colors } from '../../../Components/consts'
import { Tabs } from '../../../Components/LazyComponents'

export const HubTabsHead = styled(Tabs)(({ theme }) => ({
  background: colors.lightestGrey,
  borderRadius: '8px 8px 0 0',
  backgroundColor: colors.darkBackground,
  '& .MuiTab-textColorPrimary.Mui-selected': {
    color: colors.white,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorInherit.Mui-selected': {
    color: colors.gray.gray40,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorInherit': {
    color: colors.text,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-root': {
    color: colors.gray.gray40,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& .MuiTabs-indicator': {
    background: colors.white,
  },
}))

export const ContentCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2, 0),
  borderRadius: '0 0 8px 8px',
  background: colors.darkBackground,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1),
  },
}))

export const MapImgCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  width: '100%',
  backgroundColor: colors.black,
  '& img': {
    maxWidth: 1080,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      borderRadius: 8,
    },
  },
}))

export const FAQsCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '& p': {
    margin: theme.spacing(1.5, 0),
    color: `${colors.gray.gray20} !important`,
    fontSize: fontSizes.medium,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.9rem',
    },
    '& strong': {
      color: `${colors.gray.gray20} !important`,
    },
    '& a': {
      color: colors.lightBlue,
      textDecoration: 'none',
    }
  },
  '& span': {
    color: `${colors.gray.gray20} !important`,
    fontSize: fontSizes.medium,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.9rem',
    },
  },
  '& > ul': {
    paddingLeft: 15,
    '& li': {
      color: colors.gray.gray20,
      fontSize: fontSizes.small,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.9rem',
      },
    },
  },
}))

export const ExperienceItemCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 280,
  backgroundColor: colors.gray.gray75,
  [theme.breakpoints.down('md')]: {
    height: 200,
  },
  borderRadius: 8,
  '& img': {
    width: '100%',
    objectFit: 'cover',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  '& .experience-item-content': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    height: '40%',
    '& h3': {
      color: colors.white,
    },
    '& .button': {
      fontSize: fontSizes.medium,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.small,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
      fontWeight: 700,
      cursor: 'pointer',
      backgroundColor: colors.gray.gray40,
      padding: theme.spacing(1, 2),
      borderRadius: 10,
      textAlign: 'center',
      width: 'fit-content',
      marginTop: theme.spacing(1),
      color: colors.black,
      '&:hover': {
        backgroundColor: colors.gray.gray60,
      },
    },
  },
}))

export const ExperiencesCon = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(5),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}))

export const ExperienceModalCon = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  width: '85%',
  marginTop: theme.spacing(8),
  '& p': {
    color: colors.gray.gray40,
  },
  '& h3': {
    color: colors.white,
    fontSize: fontSizes.medium,
  },
  '& .experience-modal-footer': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: colors.gray.gray40,
    textAlign: 'center',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: colors.gray.gray60,
      cursor: 'pointer',
    },
    '& h3': {
      color: colors.black,
      fontSize: fontSizes.medium,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))
